<div class="row">
  <div class="col-12 col-md-12">
    <section>
      <div class="row">
        <form class="needs-validation container-style" [formGroup]="formMandator">
          <div class="ps-2 pe-2 pb-2">
            <div class="row">
              <div class="col-lg-3 col-md-5 col-sm-6 col-12">
                <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                  [list]="listTypeDocuments" [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-5 col-sm-6 col-12">
                <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                  (onChangeTextOnBlur)="getDigitVerification($event)"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-1">
                <app-custom-input-text formControlName="digitVerification" [labelText]="'DV'" [required]="true">
                </app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-5 col-sm-6 col-12">
                <app-custom-input-text formControlName="businessName" [labelText]="'Razón Social'"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-2">
                <app-custom-input-decimal formControlName="percentage" [labelText]="'% Mandante'"
                  [maxFractionDigits]="2"></app-custom-input-decimal>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-6 d-flex align-items-end mt-2 justify-content-start">
                <app-custom-button *ngIf="formMandator.dirty" [title]="'Limpiar'" [icon]="'pi pi-eraser'"
                  [severity]="'contrast'" (onClick)="newMandator()"></app-custom-button>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-6 d-flex align-items-end mt-2 ms-auto justify-content-end">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disabled"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </form>
        <section class="row mt-2">
          <div class="container-style mx-0">
            <div class="col-lg-12">
              <app-custom-table [headers]="header" [data]="data" [actions]="tableActions" [showCheckbox]="!disabled"
                [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger" [showExport]="true"
                [showRecover]="true" (onPageChange)="onPageChange($event)" (onRecoverData)="getMandatorsForSelection()"
                (onAction)="onAction($event)" (onExport)="onExport()">
              </app-custom-table>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</div>